if (!customElements.get('topbar-benefits')) {
  customElements.define(
    'topbar-benefits',
    class TopbarBenefits extends HTMLElement {
      constructor() {
        super();

        this.items = [];
        this.mobileMedia = window.matchMedia('(max-width: 1023.98px)');
        this.reducedMotionMedia = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.rotationSpeed = parseInt(this.dataset.rotationSpeed, 10) || 4000;
        this.rotateOnDesktop = this.dataset.rotateOnDesktop === 'true';
        this.activeIndex = 0;

        this.handleMediaChange = this.update.bind(this);
        this.handleVisibilityChange = this.update.bind(this);
      }

      connectedCallback() {
        this.mobileMedia.addEventListener('change', this.handleMediaChange);
        this.reducedMotionMedia.addEventListener('change', this.handleMediaChange);
        document.addEventListener('visibilitychange', this.handleVisibilityChange);
        window.requestAnimationFrame(() => {
          this.items = Array.from(this.querySelectorAll('[data-benefit-item]'));
          this.update();
        });
      }

      disconnectedCallback() {
        this.stop();
        this.mobileMedia.removeEventListener('change', this.handleMediaChange);
        this.reducedMotionMedia.removeEventListener('change', this.handleMediaChange);
        document.removeEventListener('visibilitychange', this.handleVisibilityChange);
      }

      update() {
        this.stop();
        const shouldRotate = this.mobileMedia.matches || this.rotateOnDesktop;
        this.classList.toggle('is-rotating', shouldRotate);

        if (!shouldRotate) {
          this.items.forEach((item) => item.classList.remove('is-active'));
          this.style.removeProperty('--benefits-rotation-height');
          return;
        }

        this.activeIndex = Math.min(this.activeIndex, Math.max(this.items.length - 1, 0));
        this.showItem(this.activeIndex);

        if (this.items.length > 1 && !this.reducedMotionMedia.matches && !document.hidden) {
          this.timer = window.setInterval(() => {
            this.activeIndex = (this.activeIndex + 1) % this.items.length;
            this.showItem(this.activeIndex);
          }, this.rotationSpeed);
        }
      }

      showItem(index) {
        this.items.forEach((item, itemIndex) => item.classList.toggle('is-active', itemIndex === index));
        const activeItem = this.items[index];
        if (activeItem) {
          this.style.setProperty('--benefits-rotation-height', `${activeItem.scrollHeight}px`);
        }
      }

      stop() {
        if (this.timer) {
          window.clearInterval(this.timer);
          this.timer = null;
        }
      }
    }
  );
}